import theme from '../../themes/green';

const styles = {
  wrapper: {
    background: theme.pallete.background,
    height: 120,
    bottom: 0,
    transform: 'translate(0, 120px)',
  },
  wrapperOpen: {
    transform: 'translate(0, -30px)',
  },
  widgets: {
    display: 'flex',
    flexFlow: 'row wrap',
    width: '100%',
    flex: 1,
  },
  widget: {
    color: theme.pallete.lightTextColor,
    width: '50%',

    ':hover': {
      color: theme.pallete.background,
    },
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/AddWidgetPanel/styles.js